var c=new Audio('https://cdn.shopify.com/s/files/1/0696/2574/1482/files/184438__capslok__cash-register-fake.wav?v=1774181381');
var s=new Audio('https://cdn.shopify.com/s/files/1/0696/2574/1482/files/90187__therentcollector__spray-paint.wav?v=1773496154');
var f={play:function(){return{catch:function(){}}},pause:function(){},volume:0,currentTime:0,loop:false};
c.volume=0.7;s.volume=0.4;f.volume=0;f.loop=true;
var sc=false,st;
window.addEventListener('scroll',function(){if(sc)return;sc=true;s.currentTime=0;s.play().catch(function(){});clearTimeout(st);st=setTimeout(function(){s.pause();sc=false;},300);},{passive:true});
var h=document.getElementById('hero');

function addToCart(handle,btn){
  c.currentTime=0;c.play().catch(function(){});
  var orig=btn?btn.textContent:'';
  if(btn){btn.textContent='ADDING...';btn.disabled=true;}
  fetch('/products/'+handle+'.js')
  .then(function(r){return r.json();})
  .then(function(p){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:p.variants[0].id,quantity:1})});})
  .then(function(){
    uc();
    if(btn){btn.textContent='✓ ADDED!';btn.style.background='#22aa44';setTimeout(function(){btn.textContent=orig;btn.style.background='';btn.disabled=false;},1500);}
  })
  .catch(function(){if(btn){btn.textContent=orig;btn.disabled=false;}window.location='/products/'+handle;});
}
window.addToCart=addToCart;
function uc(){fetch('/cart.js').then(function(r){return r.json();}).then(function(c){var el=document.getElementById('cartCount');if(el){el.textContent=c.item_count;el.style.opacity=c.item_count>0?'1':'0';}}).catch(function(){});}
uc();setInterval(uc,3000);